/**
 * EnergyControlIntakeHeroMobile — Sprint B v1.5 (Feb 2026).
 *
 * Vervangt de zwaardere desktop hero op mobiel (sm:hidden). Doel:
 *   - vragenformulier zit direct boven de vouw
 *   - prijs-belofte (€ 9,95 → € 14,95) blijft top-of-mind
 *   - één regel uitleg + één "tap one answer" affordance
 *   - geen tekstmuur boven de eerste vraag
 *
 * Geen pricing wijzigingen, geen Stripe, geen consent: pure copy/layout.
 */
import { Sparkles, Zap } from 'lucide-react';

export default function EnergyControlIntakeHeroMobile() {
  return (
    <section
      className="sm:hidden max-w-2xl mx-auto mb-4"
      data-testid="ec-intake-hero-mobile"
      aria-label="Powersure Energy Control Plan introductie (mobiel)"
    >
      <div className="rounded-xl border border-emerald-400/30 bg-gradient-to-br from-emerald-500/10 to-transparent px-4 py-3">
        <div className="flex items-center gap-2 mb-1">
          <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-emerald-500/20 border border-emerald-400/30 text-emerald-300">
            <Zap className="w-3.5 h-3.5" />
          </span>
          <span className="text-[12px] uppercase tracking-wide text-emerald-300 font-semibold">
            Mijn Powersure
          </span>
        </div>
        <h1
          className="text-[19px] font-medium text-white leading-tight"
          style={{ fontFamily: 'Outfit' }}
          data-testid="ec-intake-hero-mobile-h1"
        >
          Gratis eerste inzicht — 3 korte vragen.
        </h1>
        <div
          className="mt-2 flex items-center gap-1.5 text-[12px] font-semibold text-emerald-200"
          data-testid="ec-intake-hero-mobile-price"
        >
          <Sparkles className="w-3 h-3" />
          € 9,95/m · eerste 3 mnd · daarna € 14,95/m
        </div>
      </div>
    </section>
  );
}
